import styled from '@emotion/styled';
import { Css, Markdown } from '@/ui';
import { INewsItemEntry } from '../../../../contentful/types/INewsItemEntry';
import { IBlogItemEntry } from '../../../../contentful/types/IBlogItemEntry';
import { Section } from '../../../content-sections/ui/components/Section';
import { MarkdownRenderContextProvider } from '../../../../components/common/markdown';
import { formatFullDate } from '../../../../i18n/formatFullDate';

interface IEntryItemContentPage {
	data: INewsItemEntry | IBlogItemEntry;
}

export default function EntryItemContentPage({ data }: IEntryItemContentPage) {
	const { body, publicationDate } = data.fields;

	return (
		<Section>
			<MarkdownRenderContextProvider>
				{publicationDate && (
					<PublicationDate>{formatFullDate(publicationDate)}</PublicationDate>
				)}
				<Markdown source={body} />
			</MarkdownRenderContextProvider>
		</Section>
	);
}

const PublicationDate = styled.p`
	margin-bottom: ${Css.pxToRem(8)};
`;
